import React, { AriaAttributes } from 'react'
import Flex from '../Flex'
import Price, { PriceProps } from 'shared/library/atoms/Price/Price'
import Spinner from 'library/atoms/Spinner'
import useTranslation from 'next-translate/useTranslation'

export interface SchedulablePriceProps
  extends PriceProps,
    Pick<AriaAttributes, 'aria-label'> {
  preAdjustmentsPence?: number
  loading?: boolean
}

/**
 * Converts pence to a currency and displays it with the unit. Uses the logic from `money()`
 * whilst providing the locale internally. Provides a div wrapper for styling.
 * Displays full price with strike through it and then discounted price
 */
const SchedulablePrice = ({
  pence,
  preAdjustmentsPence,
  loading,
  ...other
}: SchedulablePriceProps) => {
  const { t } = useTranslation()

  return loading ? (
    <Spinner />
  ) : preAdjustmentsPence && preAdjustmentsPence > pence ? ( // checks benefit is being applied and renders striked price
    <Flex gap={3}>
      <Price
        {...other}
        strike={true}
        pence={preAdjustmentsPence}
        aria-label={t('common:pre-adjustments-total')}
        fontStyle="h5"
        color="tertiary"
      />
      <Price
        {...other}
        pence={pence}
        aria-label={t('common:total')}
        fontStyle="h5"
      />
    </Flex>
  ) : (
    <Price
      {...other}
      pence={pence}
      aria-label={t('common:total')}
      fontStyle="h5"
    />
  )
}

export default SchedulablePrice
